module.exports = __webpack_public_path__ + "static/media/day.78a0d3c1.png";